import { Module } from "vuex";
import { State } from "@/store/modules/award/state";
import Mutations from "@/store/modules/award/mutations";
import Getters from "@/store/modules/award/getters";
import Actions from "@/store/modules/award/actions";

export class Award implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
